/// <reference path="../../../../typings/index.d.ts" />

module Meevo.UpdateSignatureTitle {
    "use strict";

    export interface IUpdateSignatureTitleService {
        isAvailable(): ng.IPromise<boolean>;
        open(): ng.IPromise<any>;
    }

    // AB#135510: My Account "Update Signature & Title" entry point (D.1), shared by every
    // user-menu variant (profileMenu + navbar, legacy + enhanced). Self-service only - the server
    // rejects any EmployeeId but the caller's own (EmployeeLogic.EnsureMdOversightOwner).
    export class UpdateSignatureTitleService implements IUpdateSignatureTitleService {
        static $inject = ["$q", "meevo.components.common.SecurityService", "meevo.components.modal.ModalService"];

        constructor(private $q: ng.IQService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private modalService: Meevo.Components.Modal.IModalService) {
        }

        // D.2 + CC.1: the logged-in user's Approve grant AND the module on for this location.
        isAvailable(): ng.IPromise<boolean> {
            if (!this.securityService.hasSecurity(Meevo.Components.Common.SecurityKeys.DATA_CLIENT_ACTION_CHARTS_APPROVE)) {
                return this.$q.when(false);
            }
            return this.securityService.checkModuleEnabledForEffectiveLocation(Meevo.Model.ModuleEnum.MdChartOversight);
        }

        open(): ng.IPromise<any> {
            return this.modalService.showCustom({
                templateUrl: "app/components/updateSignatureTitle/updateSignatureTitle.html",
                controller: "meevo.updateSignatureTitle.UpdateSignatureTitleController",
                controllerAs: "vm",
                bindToController: true,
                locals: {}
            });
        }
    }

    angular.module("meevo")
        .service("meevo.updateSignatureTitle.UpdateSignatureTitleService", UpdateSignatureTitleService);
}
